module.exports = __webpack_public_path__ + "static/industries-food-banks-09f04723cf574782be5333ccb08f8402.png";